import React from "react";

interface AnimatedSectionProps {
  id: string;
  children: React.ReactNode;
  className?: string;
  delay?: number;
  visible: boolean;
}

export const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  id,
  children,
  className = "",
  delay = 0,
  visible,
}) => (
  <div
    id={id}
    data-animate
    className={`transition-all duration-1000 ease-out ${
      visible === false
        ? "opacity-0 translate-y-12"
        : "opacity-100 translate-y-0"
    } ${className}`}
    style={{ transitionDelay: `${delay}ms` }}
  >
    {children}
  </div>
);
